module.exports = __webpack_public_path__ + "0834dc1145840a6dc7bea46a9a6f4854.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/studio.jpg
// module id = 197
// module chunks = 0